import React, {useEffect, useState} from "react";
import {BasicProps} from "../Main";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid, useMediaQuery} from "@mui/material";
import axios from "axios";
import {handleError} from "../support";
import {SamaggiButton} from "../Components/SamaggiButton";
import {Colours} from "../Components/SamaggiTypography";
import {useNavigate} from "react-router-dom";
import theme from "../theme";
import {truncate} from "./Reimbursements";


export const LanyardAdmin: React.FC<BasicProps> = (props) => {
    const navigate = useNavigate();
    const vertical = useMediaQuery(theme.breakpoints.down("sm"));

    interface Data {
        time: number;
        name: string;
        team: string;
        role: string;
        size: string;
        imageLink: string;
        rawLink: string;
    }

    const [rows, setRows] = useState<Array<Data>>([]);

    function load() {
        props.setShowCover(true)
        const token = localStorage.getItem("token");

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/lanyard-admin/list", {token: token}).then((res) => {
            console.log(res);
            props.setShowCover(false)
            setRows(res.data.data.data as Array<Data>);
        }).catch((error) => {
            props.setShowCover(false);
            alert("Unable to Load Responses.");

            handleError(error, true);
        })
    }

    useEffect(() => {
        load(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const shortened = {
        "125 Secretarial Office": "Sec. Office",
        "125 Academic Affairs Team": "Acad.",
        "125 Marketing Team": "Mkting.",
        "125 Presidential Office": "Pres. Office"
    }

    return (
        <Grid container direction={"column"} spacing={3}>
            <Grid item>
                <TableContainer>
                    <Table aria-label="table">
                        <TableHead>
                            <TableRow>
                                <TableCell align={"center"} sx={{padding: "1px"}}>Team</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>Role</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>Name</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>Size</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>DL.</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>RW.</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.sort((a,b) => b.time - a.time).map((row) => (
                                <TableRow key={`${row.time}tr`}>
                                    <TableCell align="center" key={`${row.time}tc1`} sx={{paddingX: vertical ? "1px" : "initial"}}>{vertical && Object.keys(shortened).includes(row.team) ? shortened[row.team as keyof typeof shortened] : row.team}</TableCell>
                                    <TableCell align="center" key={`${row.time}tc2`} sx={{paddingX: vertical ? "1px" : "initial"}}>{vertical ? truncate(row.role) : row.role}</TableCell>
                                    <TableCell align="center" key={`${row.time}tc3`} sx={{paddingX: vertical ? "1px" : "initial"}}>{vertical ? truncate(row.name) : row.name}</TableCell>
                                    <TableCell align="center" key={`${row.time}tc4`} sx={{paddingX: vertical ? "1px" : "initial"}}>{row.size}</TableCell>
                                    <TableCell align="center" key={`${row.time}tc5`} sx={{paddingX: vertical ? "1px" : "initial"}}>
                                        <a href={row.imageLink}>Full</a>
                                    </TableCell>
                                    <TableCell align="center" key={`${row.time}tc6`} sx={{paddingX: vertical ? "1px" : "initial"}}>
                                        <a href={row.rawLink}>Raw</a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item>
                <SamaggiButton fullWidth onClick={() => {props.setShowCover(true); load()}}>Reload</SamaggiButton>
            </Grid>
            <Grid item>
                <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {navigate("/")}}>Back to Staff Portal</SamaggiButton>
            </Grid>
        </Grid>
    )
}
